const FOCUSABLE_SELECTOR = [
  "a[href]",
  "button:not([disabled])",
  "textarea:not([disabled])",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
].join(", ");

function isVisible(element) {
  if (!(element instanceof HTMLElement)) {
    return false;
  }

  return element.offsetParent !== null || element.getClientRects().length > 0;
}

export function getFocusableElements(container) {
  if (!(container instanceof HTMLElement)) {
    return [];
  }

  return Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(isVisible);
}

export function focusFirstElement(container) {
  if (!(container instanceof HTMLElement)) {
    return;
  }

  const [firstFocusable] = getFocusableElements(container);

  if (firstFocusable) {
    firstFocusable.focus();
    return;
  }

  container.focus();
}

export function trapFocus(container, event) {
  if (event.key !== "Tab" || !(container instanceof HTMLElement)) {
    return;
  }

  const focusableElements = getFocusableElements(container);

  if (focusableElements.length === 0) {
    event.preventDefault();
    container.focus();
    return;
  }

  const firstFocusable = focusableElements[0];
  const lastFocusable = focusableElements[focusableElements.length - 1];
  const activeElement = document.activeElement;

  if (event.shiftKey) {
    if (activeElement === firstFocusable || !container.contains(activeElement)) {
      event.preventDefault();
      lastFocusable.focus();
    }

    return;
  }

  if (activeElement === lastFocusable || !container.contains(activeElement)) {
    event.preventDefault();
    firstFocusable.focus();
  }
}
